// extracted by mini-css-extract-plugin
export default {"modalOverlay":"SuccessModal_modalOverlay__DJ24B","modalContent":"SuccessModal_modalContent__1LXTw","modalButton":"SuccessModal_modalButton__FFtPI"};